module.exports = __webpack_public_path__ + "static/media/IMG_8131.3685a7ff.JPG";